import styled from 'styled-components';
import { FONTS, COLORS, breakPoint } from '@stelecom/ui-react/assets/js/constants';
import DefaultPopup from '@stelecom/ui-react/components/popups/defaultPopup';
import Input from '@stelecom/ui-react/components/input';
import StyledButton from '@stelecom/ui-react/components/buttons/styledButton';

export const Text = styled.div`
    ${FONTS.S};
    margin-top: 10px;
`;

export const EmailPopup = styled(DefaultPopup)`
    min-height: 324px !important;
    width: 1013px !important;
    @media(${breakPoint(1024)}) {
        width: 800px !important;
    }
    @media(${breakPoint(768)}) {
        margin-left: 130px !important;
        width: auto !important;
    }
    @media(${breakPoint(320)}) {
        margin-left: 5px !important;
    }
`;

export const Header = styled.div`
    ${FONTS.H2};
    margin: 56px 20px 10px 60px;
    @media(${breakPoint(768)}) {
        margin-top: 20px;
        ${FONTS.S};
    }
    @media(${breakPoint(320)}) {
        text-align: center;
        margin-left: 10px;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: 60px;
    @media(${breakPoint(320)}) {
        margin-left: 10px;
        justify-content: center;
        text-align: center;
    }
`;

export const EmailBlock = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 20px 6px 0 0;
  width: 454px;
`;

export const EmailInput = styled(Input)`
    margin-bottom: 5px;
`;

export const EmailNotice = styled.div`
  margin: 5px 0;
  ${FONTS.XXS};
  color: ${COLORS.middleGray};
`;

export const CodeBlock = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 20px 6px 0 6px;
  width: 200px;
  @media (${breakPoint(1024)}) {
    margin: 20px 20px 20px 0;
  }
  @media (${breakPoint(320)}) {
    align-items: center;
    margin-left: 20px;
  }
`;

export const CodeInput = styled(Input)`
    margin-bottom: 5px;
`;

export const ErrorMessage = styled.div`
  margin: 5px 0;
  ${FONTS.XXS};
  color: ${COLORS.red};
`;

export const SendAgainLink = styled.a`
  max-width: 200px;
  margin: 5px 0;
  ${FONTS.XXS};
  border-bottom: 1px dotted;
  cursor: pointer;
`;

export const Button = styled(StyledButton)`
  height: 48px;
  padding: 9px 24px;
  max-width: 172px;
  margin: 20px 6px 0 6px;
  @media (${breakPoint(1024)}) {
    margin: 20px 0 20px 0;
  }
`;
